<template>

    <div>
        <div v-if="mode == 'dropzone' && !hideDropzone" class="upload-cloud-div" @click="openDialog" @drop.prevent="addFiles($event,0)" @dragover.prevent>
            <i class="ph-cloud-arrow-up upload-cloud-icon"></i>
            <div class="upload-cloud-text">{{ dropText }}</div>
            <div class="small">
                <a href="#" @click.prevent="openDialog">{{ buttonText }}</a>
                <small v-if="acceptText" class="text-muted">({{ acceptText }})</small>
            </div>
        </div>
        <button v-if="mode == 'button'" type="button" :class="buttonClass" @click="openDialog">
            <i v-if="buttonIcon" :class="buttonIcon" class="me-1"></i>{{ buttonText }}
        </button>
        <input ref="input" type="file" :multiple="multiple" class="d-none" @change="addFiles($event,1)">
        <div v-if="showPreview && previews.length" class="d-flex flex-wrap mt-2">
            <div v-for="(p,i) in previews" :key="i" class="me-1 mb-1">
                <img :src="p.src" class="rounded border" width="64" height="64" style="object-fit:cover" alt="">
            </div>
        </div>
    </div>

</template>

<script>

export default {
    name: 'UploadCloud',
    emits: ['uploaded', 'uploadedAll', 'error', 'uploading'],
    props: {
        modalita: {
            type: String,
            default: ''
        },
        args: {
            type: Object,
            default: () => { return {} }
        },
        multiple: {
            type: Boolean,
            default: false
        },
        accept: {
            type: Array,
            default: () => { return ['jpg', 'jpeg', 'png', 'gif', 'webp'] }
        },
        maxSize: {
            type: Number,
            default: 5242880
        },
        buttonText: {
            type: String,
            default: 'Seleziona file'
        },
        dropText: {
            type: String,
            default: 'Trascina qui i file da caricare'
        },
        mode: {
            type: String,
            default: 'dropzone'
        },
        buttonClass: {
            type: String,
            default: 'btn btn-outline-primary btn-sm'
        },
        buttonIcon: {
            type: String,
            default: 'ph-cloud-arrow-up'
        },
        hideDropzone: {
            type: Boolean,
            default: false
        },
        showPreview: {
            type: Boolean,
            default: true
        }
    },
    data: function () {
        return {
            files: [],
            previews: []
        }
    },
    computed: {
        acceptText() {
            return this.accept.map(e => '.' + e).join(', ');
        }
    },
    methods: {
        openDialog() {
            this.$refs.input.value = '';
            this.$refs.input.click();
        },
        addFiles(e, fromButton = 0) {
            let list = fromButton == 1 ? e.target.files : e.dataTransfer.files;
            if (!list || !list.length) return;
            this.files = Array.from(list);
            this.buildPreviews();
            this.upload();
        },
        buildPreviews() {
            this.previews = [];
            this.files.forEach(f => {
                if (f.type && f.type.indexOf('image/') === 0) {
                    this.previews.push({ src: URL.createObjectURL(f) });
                }
            });
        },
        upload() {
            if (!this.files.length) return;
            let formData = new FormData();
            this.files.forEach((f, i) => {
                formData.append('file' + (i + 1), f);
            });
            let payload = Object.assign({}, this.args);
            payload.accept = this.accept;
            payload.maxSize = this.maxSize;
            if (this.modalita !== '') {
                payload.modalita = this.modalita;
            }
            formData.append('args', JSON.stringify(payload));
            this.$emit('uploading', true);
            global.utils.uploadAjax('core/basic/upload', formData, (response) => {
                this.files = [];
                this.previews = [];
                this.$emit('uploading', false);
                if (response.esito == 0) {
                    let items = Array.isArray(response.data) ? response.data : [response];
                    items = items.filter(i => i && (i.esito === undefined || i.esito === 0 || i.esito === '0'));
                    items.forEach(it => this.$emit('uploaded', it));
                    this.$emit('uploadedAll', items);
                }
                else {
                    this.$emit('error', response);
                }
            }, true, 1);
        }
    }
}
</script>

<style scoped>
.upload-cloud-div {
    border: 2px dashed #36b9cc;
    border-radius: 6px;
    padding: 22px 12px;
    text-align: center;
    cursor: pointer;
    background: #f8fbfc;
}
.upload-cloud-div:hover {
    background: #eef8fa;
}
.upload-cloud-icon {
    font-size: 38px;
    color: #36b9cc;
    display: block;
    margin-bottom: 6px;
}
.upload-cloud-text {
    font-weight: 600;
    color: #36b9cc;
}
</style>